import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import "./styles/Navbar.css";

const Navbar = () => {
  const { user, LogOut } = useAuth();
  const location = useLocation();

  return (
    <nav className="navbar" aria-label="Navigation principale">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          WinlyDeal
        </Link>

        <ul className="navbar-menu">
          <li className="navbar-item">
            <Link 
              to="/" 
              className="navbar-link" 
              aria-current={location.pathname === '/' ? 'page' : undefined}
            >
              Accueil
            </Link>
          </li>
          <li className="navbar-item">
            <Link 
              to="/rules" 
              className="navbar-link"
              aria-current={location.pathname === '/rules' ? 'page' : undefined}
            >
              Règles
            </Link>
          </li>
          <li className="navbar-item">
            <Link 
              to="/profile" 
              className="navbar-link"
              aria-current={location.pathname === '/profile' ? 'page' : undefined}
            >
              Profil
            </Link>
          </li>
        </ul>

        <div className="navbar-cta">
          {user ? (
            <button className="cta-button" onClick={LogOut}>
              Se déconnecter
            </button>
          ) : (
            <>
              <Link 
                to="/signup" 
                className="cta-button"
                aria-current={location.pathname === '/signup' ? 'page' : undefined}
              >
                S'inscrire
              </Link>
              <Link 
                to="/login" 
                className="cta-button"
                aria-current={location.pathname === '/login' ? 'page' : undefined}
              >
                Se connecter
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
